import type { ReactElement } from 'react'
import { Icon, type IconProps } from '../icon/Icon'
import type { IconName } from '../icon/names'
import type { IconVariant } from '../icon/types'

export type IconPrefix = 'fa' | 'far' | 'fas' | 'fal' | 'fad'

export type IconProp = IconName | readonly [IconPrefix, IconName]

export type IconFaProps = Omit<IconProps, 'icon' | 'variant' | 'flip'> & {
  icon: IconProp
  pulse?: boolean
  flip?: 'horizontal'
}

// Font Awesome's prop shape, kept so call sites did not have to change: a bare name
// meant the solid style there, and 'fa', 'fas' and 'fad' were its solid prefixes.
const variantOf = (prefix: IconPrefix | undefined): IconVariant =>
  prefix === undefined || prefix === 'fa' || prefix === 'fas' || prefix === 'fad' ? 'solid' : 'regular'

export function IconFa({ icon, pulse, spin, flip, ...rest }: IconFaProps): ReactElement | null {
  const [prefix, name] = typeof icon === 'string' ? [undefined, icon] : icon
  return <Icon {...rest} icon={name} variant={variantOf(prefix)} spin={spin || pulse} flip={flip === 'horizontal'} />
}
